import { useLayoutEffect, useState } from "react";
export const FOCUS_VISIBLE_WITHIN_CLASSNAME = "focus-visible-within";
const matches = (element) => {
    return element.matches(":focus-visible") || element.matches("[data-focused]");
};
const useFocusVisibleWithin = (elRef) => {
    const [hasFocusVisibleWithin, setHasFocusVisibleWithin] = useState(false);
    useLayoutEffect(() => {
        const element = elRef.current;
        if (!element) {
            return;
        }
        const eventHandler = (e) => {
            setHasFocusVisibleWithin(matches(e.target));
        };
        ["focusin", "focusout", "keydown"].forEach((type) => {
            element.addEventListener(type, eventHandler);
        });
        return () => {
            ["focusin", "focusout", "keydown"].forEach((type) => {
                element.removeEventListener(type, eventHandler);
            });
        };
    }, [elRef.current]);
    return hasFocusVisibleWithin ? FOCUS_VISIBLE_WITHIN_CLASSNAME : "";
};
export default useFocusVisibleWithin;
//# sourceMappingURL=useFocusVisibleWithin.js.map